import formatCurrency from 'Helper/formatCurrency';
import formatNumber from 'Helper/formatNumber';

export const getTargetResponse = (response) => {
  const totalData = response?.totalData ?? 0;
  const totalPage = response?.totalPage ?? 0;
  const isDataExist = response?.isDataExist;

  const targets = response?.targets?.map((item) => {
    const shopee = item?.platformTargets?.find((platform) => platform?.ecommerce?.name?.toLowerCase() === 'shopee');
    const tiktok = item?.platformTargets?.find((platform) => platform?.ecommerce?.name?.toLowerCase() === 'tiktokshop');
    return {
      id: item?.id,
      brandName: item?.brand?.name || '-',
      targetGmv: item?.targetGmv ? formatCurrency(item?.targetGmv) : 0,
      shopeeTarget: {
        aov: shopee?.targetAov ? formatCurrency(shopee?.targetAov) : '-',
        ctr: shopee?.targetCtr ? `${formatNumber(shopee?.targetCtr)}%` : '-',
        ctor: shopee?.targetCtor ? `${formatNumber(shopee?.targetCtor)}%` : '-',
        views: shopee?.targetViews || '-',
      },
      tiktokTarget: {
        aov: tiktok?.targetAov ? formatCurrency(tiktok?.targetAov) : '-',
        ctr: tiktok?.targetCtr ? `${formatNumber(tiktok?.targetCtr)}%` : '-',
        ctor: tiktok?.targetCtor ? `${formatNumber(tiktok?.targetCtor)}%` : '-',
        views: tiktok?.targetViews || '-',
        err: tiktok?.targetErr ? `${formatNumber(tiktok?.targetErr)}%` : '-',
      },
      rawData: item,
    };
  });

  return { targets, totalData, totalPage, isDataExist };
};

export default getTargetResponse;
